import { EntraDefaultRoleScope } from "../../../../autogen/bff-api";
import { departmentsAreEnabled } from "../../../../common/departments/departmentVisibility";

interface Sourcing {
  hasBuyerAccess: boolean;
}

const takesTheDepartmentDefault = ({ hasBuyerAccess }: Sourcing): boolean => departmentsAreEnabled() && hasBuyerAccess;

export const newConnectionDefaultRoleScope = (subscription: Sourcing): EntraDefaultRoleScope =>
  takesTheDepartmentDefault(subscription) ? EntraDefaultRoleScope.DefaultDepartment : EntraDefaultRoleScope.Organization;

export const offersDefaultDepartment = (currentScope: EntraDefaultRoleScope, subscription: Sourcing): boolean =>
  takesTheDepartmentDefault(subscription) || currentScope === EntraDefaultRoleScope.DefaultDepartment;
